import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Footer.module.scss'

import { Container, Image } from 'react-bootstrap'

import GreenButton from './GreenButton'
import FeedbackForm from './FeedbackForm'

class Footer extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show_feedback: false
    }
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  render() {

    const { logo, sitename, slogan, adres, phone, sitemail, vklink, youlink, rutubelink, marshrut, assets_path, menu, produkciya, portfolio, pconf_link } = this.props,
    { show_feedback } = this.state

    return (
      <div className={styles.section}>
        <div className={styles.content}>
          <Container>
            <div className={styles.content_row}>
              <div className={styles.content_col1}>
                <div className={styles.content_col1_rowmob}>
                  <a className={styles.logo} href="/">
                    <Image
                      className={styles.logo_img}
                      width={47}
                      height={61}
                      alt={sitename}
                      src={logo}
                    />
                    <div>
                      <div className={styles.sitename}>{sitename}</div>
                      <div className={styles.slogan}>{slogan}</div>
                    </div>
                  </a>
                  <GreenButton
                    text={`Позвонить нам`}
                    width={151}
                    className={styles.btn_mob}
                    action={() => { this.showFeedback() }}
                  />
                  <FeedbackForm
                    title={`Позвонить нам`}
                    text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
                    btn={`Отправить`}
                    data={[]}
                    show={show_feedback}
                    handleClose={() => this.closeFeedback()}
                  />
                </div>
                {adres &&
                  <>
                    <div className={styles.sep}></div>
                    <div className={`d-flex align-items-center justify-content-between`}>
                      {phone != `` &&
                        <>
                          <div className={`d-sm-none`}>
                            <div className={styles.phone}>
                              <Image src={`/${assets_path}/images/phonew.svg`} alt="P" width={14} height={14} />
                              <div>
                                <a className={styles.phone_link} href={`tel:${phone.replace(/[^\d+]/g, '')}`} rel='nofollow'>{phone}</a>
                                <a className={styles.phone_sitemail} href={`mailto:${sitemail}`} rel='nofollow'>{sitemail}</a>
                              </div>
                            </div>
                          </div>
                          <div className={styles.vsep_mob}></div>
                        </>
                      }
                      <div className={styles.adres}>
                        <Image src={`/${assets_path}/images/adresw.svg`} alt="0" width={14} height={14} />
                        <div>
                          <div className={styles.adres_name}>{adres}</div>
                          <a className={styles.adres_link} target='_blank' href={marshrut} rel='nofollow'>Проложить маршрут</a>
                        </div>
                      </div>
                    </div>
                  </>
                }
                <div className={styles.sep}></div>
                {phone != `` &&
                  <div className={`d-none d-sm-block`}>
                    <div className={styles.phone}>
                      <Image src={`/${assets_path}/images/phonew.svg`} alt="P" width={14} height={14} />
                      <div>
                        <a className={styles.phone_link} href={`tel:${phone.replace(/[^\d+]/g, '')}`} rel='nofollow'>{phone}</a>
                        <a className={styles.phone_sitemail} href={`mailto:${sitemail}`} rel='nofollow'>{sitemail}</a>
                      </div>
                    </div>
                  </div>
                }
                <div className={`${styles.social} d-none d-sm-flex`}>
                  {vklink != `` &&
                    <a href={vklink} target='_blank' rel='nofollow'>
                      <Image src={`/${assets_path}/images/vk.svg`} alt="vk" width={35} height={35} />
                    </a>
                  }
                  {youlink != `` &&
                    <a href={youlink} target='_blank' rel='nofollow'>
                      <Image src={`/${assets_path}/images/you.svg`} alt="you" width={35} height={35} />
                    </a>
                  }
                  {rutubelink != `` &&
                    <a href={rutubelink} target='_blank' rel='nofollow'>
                      <Image src={`/${assets_path}/images/rutube2.svg`} alt="rut" width={35} height={35} />
                    </a>
                  }
                  <div>Наши соц-сети</div>
                </div>
              </div>
              <div className={styles.content_colmenu_spmob}>
                <div className={styles.content_colmenu}>
                  <div className={styles.menu_title}>Информация</div>
                  <a className={styles.menu_item} href={`/`}>Главная</a>
                  {menu.map( ( page, k ) => (
                    <a className={page.active ? styles.menu_item_active : styles.menu_item} key={k} href={page.href}>{page.name}</a>
                  ) )}
                </div>
                <div className={`${styles.content_colmenu} d-sm-none`}>
                  <div className={styles.menu_title}>Портфолио</div>
                  {portfolio.map( ( page, k ) => (
                    <a className={page.active ? styles.menu_item_active : styles.menu_item} key={k} href={page.href}>{page.name}</a>
                  ) )}
                </div>
              </div>
              <div className={`${styles.sep} d-sm-none`}></div>
              <div className={styles.content_colmenu}>
                <div className={styles.menu_title}>Продукция</div>
                <div className={styles.content_colmenu_katalog}>
                  {produkciya.map( ( page, k ) => (
                    <a className={page.active ? styles.menu_item_active : styles.menu_item} key={k} href={page.href}>{page.name}</a>
                  ) )}
                  <a className={styles.menu_item_green} href="/productions/">Вся продукция</a>
                </div>
              </div>
              <div className={`${styles.content_colmenu} d-none d-sm-flex`}>
                <div className={styles.menu_title}>Портфолио</div>
                {portfolio.map( ( page, k ) => (
                  <a className={page.active ? styles.menu_item_active : styles.menu_item} key={k} href={page.href}>{page.name}</a>
                ) )}
                <div className='mt-3'>
                  <GreenButton
                    text={`Позвонить нам`}
                    width={162}
                    action={() => { this.showFeedback() }}
                    className={styles.btn_hidemob}
                  />
                </div>
                <a href="/ustanovka-derevyannyh-okon" className={`${styles.menu_item} d-none d-sm-block`}>Установка деревянных окон</a>
              </div>
            </div>
          </Container>
        </div>
        <Container>
          <div className={styles.bline}>
            <div className={styles.bline_copy}>© {new Date().getFullYear()} GoodWin. Все права защищены</div>
            <div className={styles.bline_right}>
              <a className={styles.bline_pconf} href={pconf_link}>Политика конфиденциальности</a>
              <a className={styles.bline_kulibin} href={`https://kulibin-it.ru`} target='_blank' rel='nofollow'>Разработка сайта - kulibin-it.ru</a>
            </div>
            <div className={`${styles.social} d-sm-none`}>
              {vklink != `` &&
                <a href={vklink} target='_blank' rel='nofollow'>
                  <Image src={`/${assets_path}/images/vk.svg`} alt="vk" width={35} height={35} />
                </a>
              }
              {youlink != `` &&
                <a href={youlink} target='_blank' rel='nofollow'>
                  <Image src={`/${assets_path}/images/you.svg`} alt="you" width={35} height={35} />
                </a>
              }
              {rutubelink != `` &&
                <a href={rutubelink} target='_blank' rel='nofollow'>
                  <Image src={`/${assets_path}/images/rutube2.svg`} alt="rut" width={35} height={35} />
                </a>
              }
              <div>Наши соц-сети</div>
            </div>
          </div>
        </Container>
      </div>
    )
  }
}

Footer.propTypes = {
  logo: PropTypes.string,
  sitename: PropTypes.string,
  slogan: PropTypes.string,
  adres: PropTypes.string,
  phone: PropTypes.string,
  sitemail: PropTypes.string,
  vklink: PropTypes.string,
  youlink: PropTypes.string,
  rutubelink: PropTypes.string,
  marshrut: PropTypes.string,
  assets_path: PropTypes.string,
  menu: PropTypes.array,
  produkciya: PropTypes.array,
  portfolio: PropTypes.array,
  pconf_link: PropTypes.string
}

Footer.defaultProps = {
  logo: '/assets/images/logo.png',
  sitename: 'GOODWIN',
  slogan: 'Производство и установкадеревянных евроокон',
  adres: 'Нижний Новгород, ул. Белинского, д. 60А',
  phone: '8 (831) 423-29-93',
  sitemail: 'info@goodwin-nnov.ru',
  vklink: '',
  youlink: '',
  rutubelink: '',
  marshrut: '',
  assets_path: 'assets',
  menu: [],
  produkciya: [],
  portfolio: [],
  pconf_link: ``
}

export default Footer